// extracted by mini-css-extract-plugin
export default {"details":"details___T2ijY","detailsPreview":"detailsPreview___uqdT5","detailsMeta":"detailsMeta___ffEPB","detailsUrl":"detailsUrl___aJI5v"};